import { render, staticRenderFns } from "./ComissaoList.vue?vue&type=template&id=71aa5deb"
import script from "./ComissaoList.vue?vue&type=script&lang=js"
export * from "./ComissaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports